import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { ShieldCheck, AlertCircle } from 'lucide-react';

/**
 * Step di verifica 2FA: accetta codice OTP a 6 cifre OPPURE codice di recupero (ABCD-1234).
 */
const TwoFactorVerify = ({ code, setCode, error, loading, onSubmit, onBackToLogin }) => (
  <form onSubmit={onSubmit} className="space-y-4">
    <div className="flex items-center gap-2 text-slate-600 text-sm">
      <ShieldCheck className="w-5 h-5 text-blue-600" />
      <span>Apri l'app authenticator e inserisci il codice corrente</span>
    </div>

    {error && (
      <div className="flex items-center gap-2 p-3 bg-red-50 border border-red-200 rounded-md text-red-700 text-sm">
        <AlertCircle className="w-4 h-4" /> {error}
      </div>
    )}

    <div className="space-y-2">
      <Label htmlFor="code-verify">Codice 2FA (o codice di recupero)</Label>
      <Input
        id="code-verify"
        type="text"
        autoComplete="one-time-code"
        placeholder="123456 oppure ABCD-1234"
        value={code}
        onChange={(e) => setCode(e.target.value.toUpperCase())}
        className="text-center text-xl tracking-widest"
        required
        autoFocus
        data-testid="2fa-verify-code"
      />
      <p className="text-xs text-slate-400">Hai perso il telefono? Usa uno dei codici di recupero (formato ABCD-1234)</p>
    </div>

    <Button
      type="submit"
      className="w-full bg-slate-900 hover:bg-slate-800"
      disabled={loading || code.length < 6}
      data-testid="2fa-verify-btn"
    >
      {loading ? 'Verifica...' : 'Verifica e accedi'}
    </Button>

    <button
      type="button"
      className="w-full text-sm text-slate-500 hover:text-slate-700 underline"
      onClick={onBackToLogin}
    >
      Torna al login
    </button>
  </form>
);

export default TwoFactorVerify;
